import { render, staticRenderFns } from "./AdmissionManager.vue?vue&type=template&id=73973937&scoped=true"
import script from "./AdmissionManager.vue?vue&type=script&lang=js"
export * from "./AdmissionManager.vue?vue&type=script&lang=js"
import style0 from "./AdmissionManager.vue?vue&type=style&index=0&id=73973937&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73973937",
  null
  
)

export default component.exports